import { get } from '@/services/apiClient';

interface GeoResponse {
  country: string;
  language: string;
}

export async function detectLanguage(): Promise<GeoResponse> {
  return get<GeoResponse>('/api/v1/geo', { skipAuth: true });
}
